import { Component } from 'react'
import { Col, Row, Input } from 'reactstrap'
import NewBranchModal from "./NewBranchModal"
import withApolloClient from '../../withApolloClient'
import AdvancedFiltersControl from '../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'

class BranchListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            refreshRequired: false,
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }
    render() {
        return (
            <Row className="pb-3 align-items-center">
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs="auto" className="p-0">
                    <AdvancedFiltersControl entity="branch" presets={this.props.presets} setPresets={this.props.setPresets} defaultPresets={this.props.defaultPresets} />
                </Col>
                {this.state.openModal === "NewBranchModal" && <NewBranchModal handleClose={() => this.toggleModal("NewBranchModal")} open={this.state.openModal === "NewBranchModal"} handleSuccess={() => this.setState({ refreshRequired: true })} />}
                <Col className="text-right">
                    {this.props.refreshRequired ?
                        <a className="driver-list-button" color='primary' onClick={() => window.location.reload(false)}><i className="fa fa-refresh" aria-hidden="true" />&nbsp;&nbsp;Refresh Page</a> :
                        <a id="newBranch" className="driver-list-button" onClick={() => this.toggleModal("NewBranchModal")}>
                            Create New Branch | <i className="fa fa-plus" aria-hidden="true"></i>
                        </a>}
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity="branch"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                    {this.props.selectedMembers && this.props.selectedMembers.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedMembers}></i> &nbsp;&nbsp; Selected Members</span>
                        {this.props.selectedMembers.length}
                    </span>}
                </Col>
            </Row>
        )
    }
}


export default (withApolloClient(BranchListHeader)
)
